// extracted by mini-css-extract-plugin
export default {"root":"BaseModal_root__MsAI+","btnClose":"BaseModal_btnClose__R2Li5"};